import React from "react";
// NAVIGATION
import { useNavigate } from "react-router-dom";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function RolesAndPermissionsBreadcrumb() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");
	const navigate = useNavigate();

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickRole = () => {
		navigate({
			pathname: "/organization-management/roles",
		});
	};

	// ************************************************* */
	// USE EFFECT ************************************** */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Breadcrumb className=''>
			<Breadcrumb.Item>{t("header.organizationManagement")}</Breadcrumb.Item>
			<Breadcrumb.Item className='generalStyles__hoverCursor' onClick={onClickRole}>
				{t("header.roles")}
			</Breadcrumb.Item>
			<Breadcrumb.Item className='generalStyles__breadcrumbItem'>{t("general.permissions")}</Breadcrumb.Item>
		</Breadcrumb>
	);
}

export default RolesAndPermissionsBreadcrumb;
